// extracted by mini-css-extract-plugin
module.exports = {"component":"Filters_component__X7G9v","tabs":"Filters_tabs__1ObFC"};